import { createAsyncThunk } from "@reduxjs/toolkit";
import { type QueueDelivery } from "../../../domain/entities/assignment-queue";
import { type RouteAssignmentDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listQueue = createAsyncThunk<
  QueueDelivery[],
  void,
  { dispatch: RouteAssignmentDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_QUEUE, async (_, { extra }) => {
  return await extra.routeAssignmentRepo.listQueue();
});
